import { TextOverflowBox } from '@sternum/web/components/TextOverflowBox';

import { IconContainer } from '../IconContainer';
import { MenuTooltip } from '../MenuTooltip';

import { MenuItemExpandableLinkProps } from './MenuItemExpandableLink.types';

import { Content, Header, LeftBarDecoration, MenuItemExpandableLinkStyled } from './MenuItemExpandableLink.styles';

export function MenuItemExpandableLink({
  to = '#',
  icon,
  title,
  children,
  variant = 'expanded',
  tooltipThemeMode,
  ...props
}: MenuItemExpandableLinkProps) {
  if (variant === 'collapsed') {
    const renderedTitle = typeof title === 'function' ? title({ isActive: false, isPending: false }) : title;

    return (
      <MenuTooltip themeMode={tooltipThemeMode} title={renderedTitle} position="right" tooltipOffsetX={7}>
        <MenuItemExpandableLinkStyled
          role="menuitem"
          aria-label="Menu item - link"
          to={to}
          variant={variant}
          {...props}
        >
          <LeftBarDecoration />
          <Header>{icon && <IconContainer>{icon}</IconContainer>}</Header>
        </MenuItemExpandableLinkStyled>
      </MenuTooltip>
    );
  }

  return (
    <MenuItemExpandableLinkStyled role="menuitem" aria-label="Menu item - link" to={to} variant={variant} {...props}>
      {({ isActive, isPending, isTransitioning }) => {
        const renderedChildren =
          typeof children === 'function' ? children({ isActive, isPending, isTransitioning }) : children;
        const renderedTitle = typeof title === 'function' ? title({ isActive, isPending }) : title;

        return (
          <>
            <LeftBarDecoration />
            <Header>
              {icon && <IconContainer>{icon}</IconContainer>}
              <TextOverflowBox>{renderedTitle}</TextOverflowBox>
            </Header>
            <Content role="presentation" aria-label="Menu item - expanded content">
              {renderedChildren}
            </Content>
          </>
        );
      }}
    </MenuItemExpandableLinkStyled>
  );
}
